/* I Luminari 3D — theme behaviour: header, blueprint drawings, scroll motion. */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasGsap = function () { return !!(window.gsap && window.ScrollTrigger); };
  var LU = window.LU = window.LU || {};
  LU.reduce = reduce;

  /* ---------- SVG helpers ---------- */
  function el(tag, attrs, parent) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function stroke(tag, attrs, parent, cls) {
    attrs.pathLength = 1;
    attrs['class'] = cls || 'bp';
    return el(tag, attrs, parent);
  }
  LU.svg = el;

  /* Laurel crown seen from above, drawn like a technical drawing */
  LU.corona = function () {
    var svg = el('svg', { viewBox: '-210 -210 420 420', 'aria-hidden': 'true', 'class': 'bp-svg', focusable: 'false' });
    var cons = el('g', {}, svg);
    stroke('circle', { cx: 0, cy: 0, r: 176 }, cons, 'bp bp-thin');
    stroke('circle', { cx: 0, cy: 0, r: 98 }, cons, 'bp bp-thin');
    stroke('line', { x1: -200, y1: 0, x2: 200, y2: 0 }, cons, 'bp bp-thin');
    stroke('line', { x1: 0, y1: -200, x2: 0, y2: 200 }, cons, 'bp bp-thin');
    for (var t = 0; t < 72; t++) {
      var a = t * 5 * Math.PI / 180, r1 = 182, r2 = t % 6 === 0 ? 192 : 186;
      stroke('line', { x1: (Math.cos(a) * r1).toFixed(1), y1: (Math.sin(a) * r1).toFixed(1), x2: (Math.cos(a) * r2).toFixed(1), y2: (Math.sin(a) * r2).toFixed(1) }, cons, 'bp bp-thin');
    }
    stroke('circle', { cx: 0, cy: 0, r: 120 }, svg);
    stroke('circle', { cx: 0, cy: 0, r: 128 }, svg);
    var leaves = el('g', {}, svg);
    var N = 30;
    for (var i = 0; i < N; i++) {
      for (var side = -1; side <= 1; side += 2) {
        var ang = (i / N) * 360 + (side > 0 ? 6 : 0);
        var rr = side > 0 ? 150 : 104;
        var tilt = side > 0 ? -38 : 218;
        var L = side > 0 ? 30 : 22, W = side > 0 ? 9 : 7;
        var g = el('g', { transform: 'rotate(' + ang.toFixed(2) + ') translate(' + rr + ' 0) rotate(' + tilt + ')' }, leaves);
        stroke('path', { d: 'M0 ' + (-L) + ' Q' + W + ' 0 0 ' + L + ' Q' + (-W) + ' 0 0 ' + (-L) + 'Z' }, g);
        stroke('line', { x1: 0, y1: -L + 4, x2: 0, y2: L - 4 }, g, 'bp bp-thin');
      }
    }
    var berries = el('g', {}, svg);
    for (var b = 0; b < 12; b++) {
      var ba = (b / 12) * Math.PI * 2 + 0.2;
      stroke('circle', { cx: (Math.cos(ba) * 140).toFixed(1), cy: (Math.sin(ba) * 140).toFixed(1), r: 5 }, berries, 'bp berry');
    }
    var bow = el('g', { transform: 'translate(0 -150)' }, svg);
    stroke('path', { d: 'M0 0 C-30 -38 -62 -16 -48 4 C-38 18 -14 8 0 0Z' }, bow);
    stroke('path', { d: 'M0 0 C30 -38 62 -16 48 4 C38 18 14 8 0 0Z' }, bow);
    stroke('path', { d: 'M-4 4 L-26 46 M4 4 L24 48' }, bow);
    stroke('line', { x1: -128, y1: 200, x2: 128, y2: 200 }, svg, 'bp bp-thin');
    stroke('path', { d: 'M-120 195 L-128 200 L-120 205 M120 195 L128 200 L120 205 M-128 188 V206 M128 188 V206' }, svg, 'bp bp-thin');
    return svg;
  };

  /* Puglia rosone luminaria with LED points */
  LU.rosone = function () {
    var svg = el('svg', { viewBox: '-210 -210 420 420', 'aria-hidden': 'true', 'class': 'bp-svg', focusable: 'false' });
    var cons = el('g', {}, svg);
    stroke('circle', { cx: 0, cy: 0, r: 190 }, cons, 'bp bp-thin');
    for (var k = 0; k < 6; k++) {
      var a = k * Math.PI / 3;
      stroke('line', { x1: 0, y1: 0, x2: (Math.cos(a) * 200).toFixed(1), y2: (Math.sin(a) * 200).toFixed(1) }, cons, 'bp bp-thin');
    }
    var lobes = el('g', {}, svg);
    var leds = el('g', {}, svg);
    for (var i = 0; i < 6; i++) {
      var ang = i * Math.PI / 3 + Math.PI / 6;
      var cx = Math.cos(ang) * 92, cy = Math.sin(ang) * 92;
      stroke('circle', { cx: cx.toFixed(1), cy: cy.toFixed(1), r: 72 }, lobes);
      stroke('circle', { cx: cx.toFixed(1), cy: cy.toFixed(1), r: 58 }, lobes, 'bp bp-thin');
      for (var j = -3; j <= 3; j++) {
        var la = ang + j * 0.36;
        el('circle', { cx: (cx + Math.cos(la) * 72).toFixed(1), cy: (cy + Math.sin(la) * 72).toFixed(1), r: 3.6, 'class': 'led-dot' }, leds);
      }
    }
    var petals = el('g', {}, svg);
    for (var p = 0; p < 6; p++) {
      var pg = el('g', { transform: 'rotate(' + (p * 60 + 30) + ')' }, petals);
      stroke('path', { d: 'M28 0 Q74 -26 118 0 Q74 26 28 0Z' }, pg);
      stroke('path', { d: 'M44 0 Q74 -14 102 0 Q74 14 44 0Z' }, pg, 'bp bp-thin');
    }
    var star = [];
    for (var q = 0; q < 12; q++) {
      var r = q % 2 === 0 ? 44 : 22, sa = q * Math.PI / 6 - Math.PI / 2;
      star.push((Math.cos(sa) * r).toFixed(1) + ' ' + (Math.sin(sa) * r).toFixed(1));
    }
    stroke('path', { d: 'M' + star.join(' L') + 'Z' }, svg);
    stroke('circle', { cx: 0, cy: 0, r: 9 }, svg);
    el('circle', { cx: 0, cy: 0, r: 4, 'class': 'led-dot' }, leds);
    return svg;
  };

  /* Lumiè table lamp in side elevation: twisted bell on a ribbed base, with the overall dimensions */
  LU.lumie = function () {
    var svg = el('svg', { viewBox: '-210 -210 420 420', 'aria-hidden': 'true', 'class': 'bp-svg', focusable: 'false' });
    var cons = el('g', {}, svg);
    stroke('line', { x1: 0, y1: -200, x2: 0, y2: 200 }, cons, 'bp bp-thin');
    stroke('line', { x1: -200, y1: 175, x2: 200, y2: 175 }, cons, 'bp bp-thin');
    stroke('line', { x1: -170, y1: 84, x2: 170, y2: 84 }, cons, 'bp bp-thin');
    var ribs = el('g', {}, svg);
    ["M0.0 -168.0 L4.0 -163.7 L8.4 -159.5 L13.1 -155.2 L18.0 -150.9 L23.3 -146.6 L28.8 -142.4 L34.5 -138.1 L40.4 -133.8 L46.4 -129.6 L52.6 -125.3 L58.8 -121.0 L65.0 -116.7 L71.1 -112.5 L77.2 -108.2 L83.1 -103.9 L88.9 -99.7 L94.6 -95.4 L100.0 -91.1 L105.2 -86.8 L110.2 -82.6 L114.9 -78.3 L119.4 -74.0 L123.5 -69.8 L127.4 -65.5 L130.9 -61.2 L134.2 -56.9 L137.1 -52.7 L139.7 -48.4 L142.0 -44.1 L143.9 -39.9 L145.4 -35.6 L146.6 -31.3 L147.3 -27.1 L147.7 -22.8 L147.6 -18.5 L147.1 -14.2 L146.2 -10.0", "M41.2 -168.0 L46.6 -163.7 L52.2 -159.5 L58.0 -155.2 L64.0 -150.9 L70.0 -146.6 L76.1 -142.4 L82.2 -138.1 L88.4 -133.8 L94.4 -129.6 L100.3 -125.3 L106.1 -121.0 L111.6 -116.7 L116.9 -112.5 L121.8 -108.2 L126.5 -103.9 L130.8 -99.7 L134.8 -95.4 L138.4 -91.1 L141.6 -86.8 L144.5 -82.6 L147.0 -78.3 L149.1 -74.0 L150.8 -69.8 L152.1 -65.5 L153.1 -61.2 L153.7 -56.9", "M74.3 -168.0 L80.0 -163.7 L85.7 -159.5 L91.5 -155.2 L97.2 -150.9 L102.8 -146.6 L108.3 -142.4 L113.7 -138.1 L118.8 -133.8 L123.7 -129.6 L128.2 -125.3 L132.4 -121.0 L136.2 -116.7 L139.5 -112.5 L142.4 -108.2 L144.8 -103.9", "M92.6 -168.0 L97.5 -163.7 L102.2 -159.5 L106.8 -155.2 L111.2 -150.9", "M-102.8 49.8 L-97.4 54.1 L-91.7 58.4 L-85.6 62.6 L-79.1 66.9 L-72.5 71.2 L-65.7 75.5 L-58.8 79.7 L-52.0 84.0", "M-140.7 2.8 L-138.1 7.1 L-135.0 11.4 L-131.4 15.7 L-127.5 19.9 L-123.2 24.2 L-118.4 28.5 L-113.4 32.7 L-108.0 37.0 L-102.3 41.3 L-96.3 45.6 L-90.1 49.8 L-83.7 54.1 L-77.2 58.4 L-70.4 62.6 L-63.7 66.9 L-57.0 71.2 L-50.4 75.5 L-44.0 79.7 L-37.8 84.0", "M-153.3 -44.1 L-152.5 -39.9 L-151.2 -35.6 L-149.6 -31.3 L-147.6 -27.1 L-145.2 -22.8 L-142.5 -18.5 L-139.4 -14.2 L-135.9 -10.0 L-132.0 -5.7 L-127.9 -1.4 L-123.4 2.8 L-118.6 7.1 L-113.5 11.4 L-108.1 15.7 L-102.5 19.9 L-96.8 24.2 L-90.8 28.5 L-84.7 32.7 L-78.5 37.0 L-72.2 41.3 L-65.9 45.6 L-59.7 49.8 L-53.4 54.1 L-47.3 58.4 L-41.4 62.6 L-35.7 66.9 L-30.2 71.2 L-25.1 75.5 L-20.4 79.7 L-16.2 84.0", "M-149.4 -91.1 L-150.0 -86.8 L-150.2 -82.6 L-149.9 -78.3 L-149.3 -74.0 L-148.2 -69.8 L-146.8 -65.5 L-144.9 -61.2 L-142.8 -56.9 L-140.3 -52.7 L-137.4 -48.4 L-134.3 -44.1 L-130.8 -39.9 L-127.1 -35.6 L-123.0 -31.3 L-118.6 -27.1 L-114.0 -22.8 L-109.1 -18.5 L-104.0 -14.2 L-98.7 -10.0 L-93.1 -5.7 L-87.4 -1.4 L-81.6 2.8 L-75.6 7.1 L-69.5 11.4 L-63.4 15.7 L-57.3 19.9 L-51.2 24.2 L-45.2 28.5 L-39.2 32.7 L-33.4 37.0 L-27.8 41.3 L-22.5 45.6 L-17.4 49.8 L-12.6 54.1 L-8.1 58.4 L-4.1 62.6 L-0.5 66.9 L2.5 71.2 L5.1 75.5 L7.2 79.7 L8.7 84.0", "M-122.6 -138.1 L-125.7 -133.8 L-128.4 -129.6 L-130.7 -125.3 L-132.5 -121.0 L-133.7 -116.7 L-134.5 -112.5 L-134.7 -108.2 L-134.4 -103.9 L-133.7 -99.7 L-132.4 -95.4 L-130.7 -91.1 L-128.6 -86.8 L-126.1 -82.6 L-123.2 -78.3 L-119.9 -74.0 L-116.3 -69.8 L-112.3 -65.5 L-108.1 -61.2 L-103.6 -56.9 L-98.8 -52.7 L-93.9 -48.4 L-88.7 -44.1 L-83.3 -39.9 L-77.7 -35.6 L-72.0 -31.3 L-66.2 -27.1 L-60.2 -22.8 L-54.2 -18.5 L-48.1 -14.2 L-41.9 -10.0 L-35.8 -5.7 L-29.6 -1.4 L-23.6 2.8 L-17.6 7.1 L-11.8 11.4 L-6.1 15.7 L-0.7 19.9 L4.5 24.2 L9.4 28.5 L14.0 32.7 L18.2 37.0 L22.1 41.3 L25.5 45.6 L28.4 49.8 L30.8 54.1 L32.7 58.4 L34.0 62.6 L34.7 66.9 L34.8 71.2 L34.4 75.5 L33.4 79.7 L31.8 84.0", "M-92.6 -168.0 L-95.7 -163.7 L-98.5 -159.5 L-101.0 -155.2 L-103.2 -150.9 L-104.9 -146.6 L-106.3 -142.4 L-107.3 -138.1 L-107.8 -133.8 L-107.8 -129.6 L-107.3 -125.3 L-106.3 -121.0 L-104.8 -116.7 L-102.8 -112.5 L-100.4 -108.2 L-97.4 -103.9 L-94.1 -99.7 L-90.3 -95.4 L-86.2 -91.1 L-81.8 -86.8 L-77.0 -82.6 L-72.0 -78.3 L-66.8 -74.0 L-61.3 -69.8 L-55.6 -65.5 L-49.8 -61.2 L-43.9 -56.9 L-37.8 -52.7 L-31.7 -48.4 L-25.5 -44.1 L-19.3 -39.9 L-13.0 -35.6 L-6.8 -31.3 L-0.6 -27.1 L5.5 -22.8 L11.5 -18.5 L17.4 -14.2 L23.1 -10.0 L28.7 -5.7 L34.0 -1.4 L39.1 2.8 L43.8 7.1 L48.3 11.4 L52.3 15.7 L56.0 19.9 L59.3 24.2 L62.1 28.5 L64.5 32.7 L66.3 37.0 L67.6 41.3 L68.3 45.6 L68.5 49.8 L68.1 54.1 L67.0 58.4 L65.3 62.6 L63.0 66.9 L60.2 71.2 L56.8 75.5 L52.9 79.7 L48.7 84.0", "M-74.3 -168.0 L-74.9 -163.7 L-75.3 -159.5 L-75.2 -155.2 L-74.7 -150.9 L-73.8 -146.6 L-72.4 -142.4 L-70.7 -138.1 L-68.4 -133.8 L-65.8 -129.6 L-62.6 -125.3 L-59.1 -121.0 L-55.1 -116.7 L-50.8 -112.5 L-46.1 -108.2 L-41.1 -103.9 L-35.9 -99.7 L-30.3 -95.4 L-24.6 -91.1 L-18.8 -86.8 L-12.7 -82.6 L-6.6 -78.3 L-0.4 -74.0 L5.8 -69.8 L12.1 -65.5 L18.3 -61.2 L24.5 -56.9 L30.7 -52.7 L36.8 -48.4 L42.7 -44.1 L48.6 -39.9 L54.3 -35.6 L59.8 -31.3 L65.1 -27.1 L70.1 -22.8 L74.9 -18.5 L79.4 -14.2 L83.6 -10.0 L87.4 -5.7 L90.9 -1.4 L94.0 2.8 L96.6 7.1 L98.8 11.4 L100.5 15.7 L101.7 19.9 L102.4 24.2 L102.5 28.5 L102.2 32.7 L101.2 37.0 L99.7 41.3 L97.7 45.6 L95.1 49.8 L91.8 54.1 L88.1 58.4 L83.7 62.6 L78.9 66.9 L73.6 71.2 L68.0 75.5 L62.0 79.7 L55.9 84.0", "M-41.2 -168.0 L-39.4 -163.7 L-37.1 -159.5 L-34.5 -155.2 L-31.4 -150.9 L-28.0 -146.6 L-24.2 -142.4 L-20.1 -138.1 L-15.6 -133.8 L-10.7 -129.6 L-5.6 -125.3 L-0.2 -121.0 L5.4 -116.7 L11.3 -112.5 L17.2 -108.2 L23.3 -103.9 L29.5 -99.7 L35.6 -95.4 L41.8 -91.1 L48.0 -86.8 L54.1 -82.6 L60.1 -78.3 L66.0 -74.0 L71.8 -69.8 L77.4 -65.5 L82.8 -61.2 L88.1 -56.9 L93.1 -52.7 L97.9 -48.4 L102.5 -44.1 L106.8 -39.9 L110.8 -35.6 L114.5 -31.3 L117.9 -27.1 L120.9 -22.8 L123.5 -18.5 L125.7 -14.2 L127.5 -10.0 L128.9 -5.7 L129.8 -1.4 L130.3 2.8 L130.2 7.1 L129.7 11.4 L128.7 15.7 L127.2 19.9 L125.2 24.2 L122.6 28.5 L119.6 32.7 L116.1 37.0"].forEach(function (d) { stroke('path', { d: d, fill: 'none' }, ribs, 'bp bp-thin'); });
    stroke('path', { d: "M-95.0 -168.0 L-101.1 -161.7 L-107.2 -155.4 L-113.1 -149.1 L-118.8 -142.8 L-124.2 -136.5 L-129.2 -130.2 L-133.9 -123.9 L-138.0 -117.6 L-141.6 -111.3 L-144.6 -105.0 L-147.2 -98.7 L-149.3 -92.4 L-150.9 -86.1 L-152.2 -79.8 L-153.1 -73.5 L-153.7 -67.2 L-154.0 -60.9 L-154.0 -54.6 L-153.8 -48.3 L-153.4 -42.0 L-152.7 -35.7 L-151.7 -29.4 L-150.4 -23.1 L-148.7 -16.8 L-146.7 -10.5 L-144.2 -4.2 L-141.3 2.1 L-138.0 8.4 L-134.2 14.7 L-129.8 21.0 L-125.0 27.3 L-119.5 33.6 L-113.6 39.9 L-107.0 46.2 L-99.8 52.5 L-92.0 58.8 L-83.6 65.1 L-74.7 71.4 L-65.4 77.7 L-56.0 84.0 L56.0 84.0 L65.4 77.7 L74.7 71.4 L83.6 65.1 L92.0 58.8 L99.8 52.5 L107.0 46.2 L113.6 39.9 L119.5 33.6 L125.0 27.3 L129.8 21.0 L134.2 14.7 L138.0 8.4 L141.3 2.1 L144.2 -4.2 L146.7 -10.5 L148.7 -16.8 L150.4 -23.1 L151.7 -29.4 L152.7 -35.7 L153.4 -42.0 L153.8 -48.3 L154.0 -54.6 L154.0 -60.9 L153.7 -67.2 L153.1 -73.5 L152.2 -79.8 L150.9 -86.1 L149.3 -92.4 L147.2 -98.7 L144.6 -105.0 L141.6 -111.3 L138.0 -117.6 L133.9 -123.9 L129.2 -130.2 L124.2 -136.5 L118.8 -142.8 L113.1 -149.1 L107.2 -155.4 L101.1 -161.7 L95.0 -168.0", fill: 'none' }, svg);
    stroke('ellipse', { cx: 0, cy: -168, rx: 95, ry: 10 }, svg);
    stroke('rect', { x: -56, y: 84, width: 112, height: 91 }, svg);
    var base = el('g', {}, svg);
    for (var x = -48; x <= 48; x += 8) stroke('line', { x1: x, y1: 88, x2: x, y2: 171 }, base, 'bp bp-thin');
    stroke('path', { d: 'M56 160 C96 160 120 176 150 176 L200 176' }, svg, 'bp bp-thin');
    stroke('circle', { cx: 0, cy: 40, r: 20 }, svg, 'bp bp-thin');
    stroke('rect', { x: -10, y: 60, width: 20, height: 24 }, svg, 'bp bp-thin');
    el('circle', { cx: 0, cy: 40, r: 4, 'class': 'led-dot' }, svg);
    stroke('path', { d: 'M192 -168 V175 M186 -168 H198 M186 175 H198 M188 -160 L192 -168 L196 -160 M188 167 L192 175 L196 167' }, svg, 'bp bp-thin');
    stroke('path', { d: 'M-154 -196 H154 M-154 -202 V-190 M154 -202 V-190 M-146 -200 L-154 -196 L-146 -192 M146 -200 L154 -196 L146 -192' }, svg, 'bp bp-thin');
    return svg;
  };

  /* Product cards: the warm hover light follows the mouse */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var glowCard = null, glowX = 0, glowY = 0, glowRaf = 0;
    document.addEventListener('pointermove', function (e) {
      var img = e.target.closest && e.target.closest('.card-img');
      if (!img) return;
      glowCard = img; glowX = e.clientX; glowY = e.clientY;
      if (glowRaf) return;
      glowRaf = requestAnimationFrame(function () {
        glowRaf = 0;
        var b = glowCard.getBoundingClientRect();
        glowCard.style.setProperty('--mx', ((glowX - b.left) / b.width * 100).toFixed(1) + '%');
        glowCard.style.setProperty('--my', ((glowY - b.top) / b.height * 100).toFixed(1) + '%');
      });
    }, { passive: true });
  }

  function mountBlueprints(root) {
    root.querySelectorAll('[data-blueprint]').forEach(function (box) {
      if (box.querySelector('svg')) return;
      var kind = box.getAttribute('data-blueprint');
      if (LU[kind]) box.appendChild(LU[kind]());
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var btn = header.querySelector('[data-menu-open]');
    var drawer = document.querySelector('[data-drawer]');
    if (btn && drawer) {
      var close = drawer.querySelector('[data-menu-close]');
      var open = function () {
        drawer.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        close.focus();
      };
      var shut = function () {
        drawer.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        btn.focus();
      };
      btn.addEventListener('click', open);
      close.addEventListener('click', shut);
      drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
      // On wide screens the menu is a side panel: a click on the dimmed page closes it
      document.addEventListener('click', function (e) {
        if (drawer.hidden || drawer.contains(e.target) || btn.contains(e.target)) return;
        e.preventDefault();
        e.stopPropagation();
        shut();
      }, true);
    }
    /* Pages that open on a dark band: light logo until the band scrolls away */
    var darkTop = document.querySelector('[data-nav-dark]');
    if (darkTop && !document.querySelector('[data-intro]')) {
      var sync = function () {
        var dark = darkTop.getBoundingClientRect().bottom > 70;
        header.classList.toggle('on-dark', dark);
        header.classList.toggle('solid', !dark);
      };
      sync();
      window.addEventListener('scroll', sync, { passive: true });
    }
  }

  /* ---------- Motion ---------- */
  function drawOnScroll(svg, trigger) {
    var paths = svg.querySelectorAll('.bp');
    gsap.set(paths, { strokeDasharray: 1, strokeDashoffset: 1 });
    gsap.to(paths, { strokeDashoffset: 0, ease: 'none', stagger: { each: 0.004 },
      scrollTrigger: { trigger: trigger, start: 'top 85%', end: 'center 45%', scrub: 1 } });
  }

  function initReveals(root) {
    var items = gsap.utils.toArray(root.querySelectorAll('.rv')).filter(function (n) {
      return n.getBoundingClientRect().top > window.innerHeight * 0.92;
    });
    if (!items.length) return;
    gsap.set(items, { opacity: 0, y: 28 });
    ScrollTrigger.batch(items, {
      start: 'top 92%',
      onEnter: function (batch) { gsap.to(batch, { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out', stagger: 0.08, overwrite: true }); }
    });
  }

  function initCounters(root) {
    root.querySelectorAll('[data-count]').forEach(function (n) {
      var raw = n.getAttribute('data-count');
      var end = parseFloat(raw.replace(',', '.'));
      if (isNaN(end)) return;
      var dec = (raw.split(/[.,]/)[1] || '').length;
      var txt = n.textContent;
      var obj = { v: 0 };
      ScrollTrigger.create({ trigger: n, start: 'top 90%', once: true, onEnter: function () {
        gsap.to(obj, { v: end, duration: 1.4, ease: 'power3.out', onUpdate: function () {
          n.textContent = txt.replace(/[\d.,]+/, obj.v.toFixed(dec).replace('.', ','));
        } });
      } });
    });
  }

  /* Home opening: logo, then the crown alone on black, then the rosone, then the two halves open */
  function initIntro(intro) {
    if (intro.classList.contains('is-seen')) return;
    var header = document.querySelector('[data-header]');
    var img = intro.querySelector('.lu-intro__logo img');
    var q = function (s) { return intro.querySelectorAll(s); };
    gsap.set(img, { '--mp': '100%' });
    gsap.set(q('.lu-intro__glow'), { opacity: 0, scale: 0.5 });
    gsap.set(q('.lu-intro__tag, .lu-intro__cue'), { opacity: 0, y: 12 });
    // The page is still loading while the logo appears: if the browser stalls for a moment, the animation waits
    // instead of jumping ahead, so it is always seen from start to finish.
    gsap.ticker.lagSmoothing(80, 33);
    gsap.timeline({ onComplete: function () { gsap.ticker.lagSmoothing(500, 33); } })
      .to(img, { '--mp': '0%', duration: 1.8, ease: 'power2.inOut' })
      .to(q('.lu-intro__glow'), { keyframes: [{ opacity: 0.55, scale: 0.8, duration: 0.07 }, { opacity: 0.08, duration: 0.1 }, { opacity: 0.7, duration: 0.06 }, { opacity: 0.15, duration: 0.12 }, { opacity: 1, scale: 1, duration: 0.9, ease: 'power3.out' }] }, '-=0.3')
      .to(q('.lu-intro__glint'), { keyframes: [{ scale: 1.2, opacity: 1, duration: 0.25, ease: 'power2.out' }, { scale: 0, opacity: 0, duration: 0.5, ease: 'power2.in' }], stagger: 0.12 }, '-=0.6')
      .to(q('.lu-intro__cue'), { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, '-=0.38')
      // The caption under the logo comes in early, the rest keeps its pace
      .to(q('.lu-intro__tag'), { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' }, 1.0);
    gsap.to(q('.lu-intro__glow'), { opacity: 0.8, duration: 2.4, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: 4 });

    var mm = gsap.matchMedia();
    mm.add({ desk: '(min-width: 900px)', mob: '(max-width: 899px)' }, function (ctx) {
      var desk = ctx.conditions.desk;
      if (header) header.classList.add('hide');
      var cor = q('.lu-intro__half--l .bp');
      var ros = q('.lu-intro__half--r .bp');
      var corSvg = q('.lu-intro__half--l svg'), rosSvg = q('.lu-intro__half--r svg');
      gsap.set([cor, ros], { strokeDasharray: 1, strokeDashoffset: 1 });
      gsap.set(q('.lu-intro__half--r .led-dot'), { opacity: 0 });
      gsap.set([corSvg, rosSvg], { opacity: 0 });
      var open = desk ? { xPercent: -100 } : { yPercent: -100 };
      var openR = desk ? { xPercent: 100 } : { yPercent: 100 };
      var tl = gsap.timeline({ scrollTrigger: {
        trigger: intro, start: 'top top', end: 'bottom bottom', scrub: 1,
        onUpdate: function (st) {
          if (header) header.classList.toggle('hide', st.progress < 0.9);
          // WhatsApp bubble and back-to-top button stay away until the black opening is over
          document.documentElement.classList.toggle('intro-on', st.progress < 0.9);
          if (st.progress > 0.97) { try { sessionStorage.setItem('lu-intro-seen', '1'); } catch (e) {} }
        }
      } });
      tl.to(q('.lu-intro__logo-stage'), { autoAlpha: 0, duration: 0.8, ease: 'none' }, 0.2)
        .to(q('.lu-intro__logo-stage > *'), { y: -60, scale: 0.92, duration: 1, ease: 'none' }, 0)
        .fromTo(q('.lu-intro__seam'), desk ? { scaleY: 0 } : { scaleX: 0 }, Object.assign(desk ? { scaleY: 1 } : { scaleX: 1 }, { duration: 0.8, ease: 'none' }), 0.6)
        .from(q('.lu-intro__half--l .lu-intro__lab'), { opacity: 0, y: 24, duration: 0.6, ease: 'none' }, 0.9)
        .to(corSvg, { opacity: 1, duration: 0.2, ease: 'none' }, 0.9)
        // The second drawing starts while the first is still being traced, and the halves open as soon as
        // the lights are on: no moment where the screen just waits.
        .to(cor, { strokeDashoffset: 0, duration: 1.4, ease: 'none', stagger: { amount: 0.8 } }, 0.9)
        .to(q('.lu-intro__half--l .berry'), { fill: '#C8A55E', duration: 0.5, ease: 'none', stagger: 0.03 }, 2.4)
        .from(q('.lu-intro__half--r .lu-intro__lab'), { opacity: 0, y: 24, duration: 0.6, ease: 'none' }, 2.1)
        .to(rosSvg, { opacity: 1, duration: 0.2, ease: 'none' }, 2.1)
        .to(ros, { strokeDashoffset: 0, duration: 1.4, ease: 'none', stagger: { amount: 0.8 } }, 2.1)
        .to(q('.lu-intro__half--r .led-dot'), { opacity: 1, fill: '#FFE3A6', duration: 0.5, ease: 'none', stagger: { amount: 0.5, from: 'random' } }, 3.7)
        .to(rosSvg, { filter: 'drop-shadow(0 0 10px rgba(255,214,140,.45))', duration: 0.5, ease: 'none' }, 3.9)
        .from(q('.lu-intro__foot, .lu-intro__note'), { opacity: 0, duration: 0.4, ease: 'none' }, 3.9)
        .to(q('.lu-intro__seam, .lu-intro__note'), { opacity: 0, duration: 0.4, ease: 'none' }, 4.6)
        .to(q('.lu-intro__half--l'), Object.assign(open, { duration: 1.4, ease: 'power1.inOut' }), 4.7)
        .to(q('.lu-intro__half--r'), Object.assign(openR, { duration: 1.4, ease: 'power1.inOut' }), 4.7)
        .fromTo(q('.lu-intro__hero .wrap'), { scale: 0.94, opacity: 0.3 }, { scale: 1, opacity: 1, duration: 1.4, ease: 'power1.out' }, 4.8);
      intro.classList.add('is-ready');

      /* One gesture is enough: a tap on the logo, a scroll, a swipe or the arrow keys start the opening,
         which then plays by itself to the home. While it plays, other scrolling is held back. */
      var st = tl.scrollTrigger, playing = false, touchY = null;
      var endY = function () { return st.end; };
      var inIntro = function () { return window.scrollY < endY() - 4; };
      var ease = function (t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };
      // Scrolling inside an open panel (menu, search, cart, Lumi) never starts the opening
      var inPanel = function (e) { return !!(e.target && e.target.closest && e.target.closest('[role="dialog"], [aria-modal="true"], .drawer, .srch, .lumi-chat, .nav__menu')); };
      function play() {
        if (playing || !inIntro()) return;
        playing = true;
        intro.classList.add('is-playing');
        var from = window.scrollY, to = endY() + 2, dist = to - from;
        var full = Math.max(1, st.end - st.start);
        var dur = Math.max(1500, (desk ? 5000 : 4500) * dist / full);
        var elapsed = 0, last = performance.now();
        (function step(now) {
          // Holding a finger or the mouse down pauses the opening, like an Instagram story
          if (!paused) elapsed += now - last;
          last = now;
          var p = Math.min(1, elapsed / dur);
          window.scrollTo({ top: from + dist * ease(p), behavior: 'instant' });
          if (p < 1 && playing) requestAnimationFrame(step);
          else { playing = false; paused = false; intro.classList.remove('is-playing'); }
        })(last);
      }
      var paused = false;
      function onHold() { if (playing) paused = true; }
      function onRelease() { paused = false; }
      function onWheel(e) {
        if (inPanel(e)) return;
        if (playing) { e.preventDefault(); return; }
        if (e.deltaY > 0 && inIntro()) { e.preventDefault(); play(); }
      }
      function onTouchStart(e) { touchY = e.touches[0].clientY; onHold(); }
      function onTouchMove(e) {
        if (inPanel(e)) return;
        if (playing) { if (e.cancelable) e.preventDefault(); return; }
        if (touchY === null || !inIntro()) return;
        if (touchY - e.touches[0].clientY > 8) { if (e.cancelable) e.preventDefault(); play(); }
      }
      function onKey(e) {
        if (inPanel(e)) return;
        if (/input|textarea|select/i.test((e.target && e.target.tagName) || '') || (e.target && e.target.isContentEditable)) return;
        if (playing && /^(ArrowDown|ArrowUp|PageDown|PageUp| |Spacebar|End|Home)$/.test(e.key)) { e.preventDefault(); return; }
        if (/^(ArrowDown|PageDown| |Spacebar|End|Enter)$/.test(e.key) && inIntro()) { e.preventDefault(); play(); }
      }
      function onClick(e) {
        if (e.target.closest('.lu-intro__logo-stage, .lu-intro__half')) { e.preventDefault(); play(); }
      }
      window.addEventListener('wheel', onWheel, { passive: false });
      window.addEventListener('touchstart', onTouchStart, { passive: true });
      window.addEventListener('touchmove', onTouchMove, { passive: false });
      window.addEventListener('keydown', onKey);
      intro.addEventListener('click', onClick);
      // Long press during the opening: no context menu (image save, link preview)
      function onMenu(e) { if (playing || inIntro()) e.preventDefault(); }
      intro.addEventListener('contextmenu', onMenu);
      window.addEventListener('mousedown', onHold);
      ['touchend', 'touchcancel', 'mouseup', 'blur'].forEach(function (t) { window.addEventListener(t, onRelease); });

      return function () {
        if (header) header.classList.remove('hide');
        playing = false;
        window.removeEventListener('wheel', onWheel);
        window.removeEventListener('touchstart', onTouchStart);
        window.removeEventListener('touchmove', onTouchMove);
        window.removeEventListener('keydown', onKey);
        intro.removeEventListener('click', onClick);
        intro.removeEventListener('contextmenu', onMenu);
        window.removeEventListener('mousedown', onHold);
        ['touchend', 'touchcancel', 'mouseup', 'blur'].forEach(function (t) { window.removeEventListener(t, onRelease); });
      };
    });
  }

  function initShelf(shelf) {
    if (!shelf.offsetParent && getComputedStyle(shelf).position !== 'fixed') return;
    var mm = gsap.matchMedia();
    mm.add('(min-width: 900px)', function () {
      var pin = shelf.querySelector('.lu-shelf__pin');
      var track = shelf.querySelector('.lu-shelf__track');
      if (!pin || !track) return;
      var dist = function () { return Math.max(0, track.scrollWidth - track.parentElement.clientWidth + 40); };
      var size = function () { pin.style.height = (dist() + window.innerHeight) + 'px'; };
      size();
      gsap.to(track, { x: function () { return -dist(); }, ease: 'none',
        scrollTrigger: { trigger: pin, start: 'top top', end: function () { return '+=' + dist(); }, scrub: 1, invalidateOnRefresh: true, onRefreshInit: size } });
      return function () { pin.style.height = ''; };
    });
  }

  function initFills(root) {
    root.querySelectorAll('[data-fill]').forEach(function (box) {
      var fill = box.querySelector('[data-fill-line]');
      if (!fill) return;
      var horizontal = box.getAttribute('data-fill') === 'x';
      var mm = gsap.matchMedia();
      mm.add({ desk: '(min-width: 900px)', mob: '(max-width: 899px)' }, function (c) {
        var x = horizontal && c.conditions.desk;
        gsap.fromTo(fill, x ? { scaleX: 0 } : { scaleY: 0 }, Object.assign(x ? { scaleX: 1 } : { scaleY: 1 }, {
          ease: 'none', scrollTrigger: { trigger: box, start: 'top 80%', end: 'bottom 60%', scrub: 1 } }));
      });
    });
  }

  function initSection(root) {
    mountBlueprints(root);
    if (!hasGsap() || reduce) return;
    var intro = root.matches && root.matches('[data-intro]') ? root : root.querySelector('[data-intro]');
    if (intro) initIntro(intro);
    root.querySelectorAll('[data-shelf]').forEach(initShelf);
    root.querySelectorAll('[data-draw-scroll] svg').forEach(function (svg) { drawOnScroll(svg, svg.parentElement); });
    root.querySelectorAll('[data-draw-load] svg').forEach(function (svg) {
      var paths = svg.querySelectorAll('.bp');
      gsap.set(paths, { strokeDasharray: 1, strokeDashoffset: 1 });
      gsap.to(paths, { strokeDashoffset: 0, duration: 2.6, ease: 'power2.inOut', stagger: { amount: 1.4 } });
      gsap.to(svg.querySelectorAll('.led-dot'), { fill: '#FFE3A6', opacity: 1, duration: 0.3, stagger: { amount: 0.8, from: 'random' }, delay: 2.0 });
    });
    initFills(root);
    initCounters(root);
    initReveals(root);
  }

  /* Back-to-top button, bottom left: appears after a screen and a half of scrolling */
  function initToTop() {
    var btn = document.querySelector('[data-to-top]');
    if (!btn) return;
    btn.hidden = false;
    var ticking = false;
    var update = function () {
      ticking = false;
      btn.classList.toggle('is-on', window.scrollY > window.innerHeight * 1.5);
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var skip = document.querySelector('.skip-link');
      if (skip) skip.focus({ preventScroll: true });
    });
  }

  /* Links typed by hand in descriptions, pages and text blocks point at the Italian shop (/products/…,
     https://www.iluminari3d.com/pages/…). On a translated storefront send them to the same language:
     Shopify then forwards the Italian handle to the translated one. */
  function localizeLinks() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root === '/') return;
    var prefix = root.replace(/\/$/, '');
    var host = location.hostname.replace(/^www\./, '');
    document.querySelectorAll('a[href]').forEach(function (a) {
      var u;
      try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
      if (u.hostname.replace(/^www\./, '') !== host) return;
      if (!/^\/(products|collections|pages|blogs|search|cart)(\/|$)/.test(u.pathname)) return;
      a.href = prefix + u.pathname + u.search + u.hash;
    });
  }

  function boot() {
    // The head script adds .motion before the first paint, so the intro never flashes its static layout;
    // drop it again here if the animation libraries didn't load.
    if (hasGsap() && !reduce) {
      gsap.registerPlugin(ScrollTrigger);
      document.documentElement.classList.add('motion');
    } else {
      document.documentElement.classList.remove('motion', 'intro-on');
    }
    initHeader();
    initToTop();
    localizeLinks();
    // close the language list when tapping elsewhere
    var langFloat = document.querySelector('[data-lang-float]');
    if (langFloat) document.addEventListener('click', function (e) { if (langFloat.open && !langFloat.contains(e.target)) langFloat.open = false; });
    initSection(document);
    // the opening screen may show the home now (also when the intro was skipped)
    document.documentElement.classList.remove('intro-wait');
    requestAnimationFrame(function () { document.querySelectorAll('.lu-intro').forEach(function (n) { n.classList.add('is-ready'); }); });
    if (hasGsap()) {
      window.addEventListener('load', function () { ScrollTrigger.refresh(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  /* Theme editor: rebuild a section when the merchant edits it */
  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target);
    if (hasGsap()) ScrollTrigger.refresh();
  });

  var booted = false;
  function start() { if (!booted) { booted = true; boot(); } }
  // blueprints.js is loaded before this file, so once the page is parsed nothing else is needed:
  // start right away instead of waiting for every other script on the page (apps included).
  if (document.readyState !== 'loading') start();
  else { document.addEventListener('DOMContentLoaded', start); window.addEventListener('load', start); }
})();

/* Cookie banner (Consentmo) lives in a shadow root: restyle it in the theme colours, keeping accept and reject equally prominent. */
(function () {
  var css = '.csm-cookie-box-window{--csm-ccb-color:#EDEAE1!important;--csm-cc-background:#0B0B0A!important;--csm-ccb-button-color:#C8A55E!important;--csm-ccb-button-text-color:#16130B!important;border:1px solid rgba(200,165,94,.35)!important;border-radius:14px!important;font-family:"Hanken Grotesk",system-ui,sans-serif!important}' +
    '.csm-cookie-box-window *{--banner-text-color:#EDEAE1!important}' +
    '.cc-link{color:#C8A55E!important}' +
    '.cc-btn{--csm-button-border-radius:999px!important;--button-border-radius:999px!important;font-weight:600!important}' +
    '.cc-allow,.cc-deny{--csm-button-background-color:#C8A55E!important;--csm-button-outline-color:#C8A55E!important;--csm-button-text-color:#16130B!important}' +
    '.cc-settings{--csm-button-background-color:transparent!important;--csm-button-outline-color:rgba(237,234,225,.45)!important;--csm-button-text-color:#EDEAE1!important}';
  function style(host) {
    var root = host && host.shadowRoot;
    if (!root || root.querySelector('style[data-lu]')) return !!root;
    var s = document.createElement('style');
    s.setAttribute('data-lu', '');
    s.textContent = css;
    root.appendChild(s);
    return true;
  }
  function find() { return style(document.querySelector('csm-cookie-consent')); }
  var tries = 0;
  (function poll() { if (find() || ++tries > 60) return; setTimeout(poll, 250); })();
})();
